import { inject, Injectable } from '@angular/core';
import { SwiperOptions } from 'swiper/types';
import { ScreenSizeStore } from '../stores/screen-size.store';

@Injectable({
  providedIn: 'root',
})
export class SwiperConfigService {
  private screenSizeStore = inject(ScreenSizeStore);

  getResponsiveSlidesPerView(mobile: number, desktop: number): number {
    return this.screenSizeStore.isMobileSize() ? mobile : desktop;
  }

  getDefaultConfig(): SwiperOptions {
    return {
      navigation: false,
      slidesPerView: this.getResponsiveSlidesPerView(1.5, 5),
      spaceBetween: 10,
      centeredSlides: true,
      initialSlide: 2,
    };
  }

  getLoopConfig(): SwiperOptions {
    return {
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: { clickable: true },
      slidesPerView: 1,
      spaceBetween: 0,
    };
  }

  getVerticalConfig(): SwiperOptions {
    return {
      direction: 'vertical',
      slidesPerView: 'auto',
      spaceBetween: 12,
      freeMode: true,
      mousewheel: true,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        hide: false,
      },
    };
  }

  createConfig(
    mobileSlides: number,
    desktopSlides: number,
    options?: Partial<SwiperOptions>
  ): SwiperOptions {
    return {
      loop: false,
      navigation: false,
      slidesPerView: this.getResponsiveSlidesPerView(
        mobileSlides,
        desktopSlides
      ),
      spaceBetween: 10,
      ...options,
    };
  }
}
